import Marquee from "react-fast-marquee";
import TestimonialCard from "./TestimonialCard";

export default function TestimonialMarquee({ creators, colors }) {
  return (
    <Marquee gradient={false}>
      {creators.map((creator, idx) => (
        <div key={idx} className="mx-3 self-stretch flex">
          <TestimonialCard creator={creator} colors={colors} />
        </div>
      ))}
    </Marquee>
  );
}
